module.exports = __webpack_public_path__ + "media/images/athletes/2122-a0fe11beaf86ed9ffaf4c919c6767067.png";